import { connect } from "react-redux";

import {
  reducer,
  mapStateToProps,
  mapDispatchToProps,
} from "./UserSettingsPage.state";
import UserSettingsPage from "./UserSettingsPage";

export default connect(mapStateToProps, mapDispatchToProps)(UserSettingsPage);

export { reducer, mapStateToProps, mapDispatchToProps };
